// @baseFontFamily:        "Lato", sans-serif;
export const baseFontFamily = "'Lato', sans-serif";
// @boldFontFamily:        "Lato-Bold", "Lato", sans-serif;
export const boldFontFamily = "'Lato-Bold', 'Lato', sans-serif";
// @kaGreen:               #71b307;
export const kaGreen = "#71B307";

export const white = "#FFFFFF";
export const gray97 = "#F6F7F7";
export const gray85 = "#D6D8DA";
export const gray76 = "#BABEC2";
export const gray68 = "#888D93";
export const gray17 = "#21242c";

// @pure-sm-min: 568px;
export const pureSmMin = "568px";
// @pure-md-min: 768px;
export const pureMdMin = "768px";
// @pure-lg-min: 1024px;
export const pureLgMin = "1024px";
// @pure-xl-min: 1280px;
export const pureXlMin = "1280px";
// @pure-xs-max: (@pure-sm-min - 1);
export const pureXsMax = "567px";
// @pure-sm-max: (@pure-md-min - 1);
export const pureSmMax = "767px";
// @pure-md-max: (@pure-lg-min - 1);
export const pureMdMax = "1023px";
// @pure-lg-max: (@pure-xl-min - 1);
export const pureLgMax = "1279px";
// @tableBackgroundAccent: #f9f9f9; // for striping
export const tableBackgroundAccent = "#F9F9F9";
// @phoneMargin: 16px;
export const phoneMargin = 16;

export const negativePhoneMargin = -16;
export const hintBorderWidth = 4;

// The 'base unit' -- our new typography and layout styles are defined in
// terms of multiples of the 'base unit'.
export const baseUnitPx = 16;

export const interactiveSizes = {
    defaultBoxSize: 400,
    defaultBoxSizeSmall: 288,
} as const;

export const circleSize = 24;
export const radioMarginWidth = 2;

export const warningColor = "#f86700";
export const warningColorHover = "#df5c00";
export const warningColorActive = "#c75300";

export const publishBlockingErrorColor = "#be2612";

export const radioBorderColor = "#BABEC2";
export const checkedColor = "#71B307";

export const articleMaxWidthInPx = 688;
export const articleMaxWidthTableInPx = 512;
